export default ({...props}) => {
  const {space} = props.theme
  return `
    display: flex;
    gap: ${space(3)}px;
    padding-top: ${space(3)}px;

    &.cursor-not-allowed {
      cursor: not-allowed;

      & > button.btn-disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }

    & > div.MuiBox-root {
      flex-grow: 0;
      flex-basis: ${space(12.5)}%;
    }

    & button {
      text-transform: capitalize;
    }

    & > div.MuiBox-root.cursor-not-allowed {
      cursor: not-allowed;

      & > button.btn-disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }
    
    @media screen and (max-width:321px){
      flex-flow: column;
    }
    
    `
}
